module.exports = __webpack_public_path__ + "warning-512.png?205c5f";


//////////////////
// WEBPACK FOOTER
// ./client/assets/warning-512.png
// module id = 264
// module chunks = 0